const readingMediumOptions = [
  { id: 17, text: 'B' },
  { id: 18, text: 'LA' },
  { id: 19, text: 'A' },
];

export default readingMediumOptions;
